export function factoringTableConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu:false,
    refreshBtn:true,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    indexLabelWidth: 35,
    searchShow: false,
    selection:true,
    selectionWidth:35,
    showSummary: true,
    border:true,
    sumColumnList: [
      {
        name: "factoringCredit",
        overHidden: true,
        type: "sum",
      }
    ],
    column: [{
      label: '项目名称',
      searchPlaceholder: "请输入项目名称",
      placeholder: '请输入项目名称',
      prop: "name",
      slot: true,
      search: true,
      overHidden: true,
      width: '230'
    },{
      label: '项目编号',
      prop: "number",
      overHidden: true,
      width: "120",
    },{
      label: '保理类型',
      prop: "projectTypeStr",
      width	: '150'
    },{
      label: '客户名称',
      prop: "sellerCustName",
      search: true,
      searchPlaceholder: "请输入客户名称",
      overHidden: true,
      width	: '200'
    },{
      label: '保理额度（元）',
      prop: "factoringCredit",
      width: "180",
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '业务主办',
      width: "120",
      prop: "managerUserName",
      overHidden: true,
    },{
      label: '业务协办',
      width: "120",
      prop: "assistUserName",
      overHidden: true,
    },{
      label: '所属部门',
      width: "120",
      prop: "managerDeptName",
      overHidden: true,
    },{
      label: '立项状态',
      prop: "auditStatus",
      type: "select",
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_build_state',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      search: true,
      hide: true
    },
    {
      label: '日期范围',
      prop: 'timePic',
      type:'daterange',
      searchSpan:12,
      searchRange:true,
      search:true,
      hide:true
    }, 
    // {
    //   label: '立项审批表',
    //   width: "120",
    //   prop: "managerUser",
    //   overHidden: true,
    // },
    {
        label: '保理商',
        prop: "accountingEntity",
        width: '180',
        overHidden: true,
        formatter: (row, value, label, column) => {
          return `台金商业保理（天津）有限公司`;
        }
    },    
    {
      label: '立项状态',
      width: "120",
      prop: "auditStatusStr",
      overHidden: true,
    },
    {
      label: '创建时间',
      prop: "createTime",
      overHidden: true,
    }
    // {
    //   label: '审核状态',
    //   prop: "auditStatus",
    //   type: "select",
    //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
    //   props: {
    //     label: "dictValue",
    //     value: "dictKey",
    //   },
    //   formatter: (row, value, label, column) => {
    //     return label ? label : "未提交";
    //   },
    //   dataType: "string",      
    //   search: true,
    //   hide: true
    // }
    ]
  }
}

export function factoringFilterConfig(selectDeptClick, selectPersonClick) {
  return {
    // labelWidth: 140,
    // emptyBtn: false,
    // submitBtn: false,    
    column: [{
      label: '项目名称',
      placeholder: '请输入项目名称',
      prop: "name",
      formslot: false
    },{
      label: '客户名称',
      placeholder: '请输入客户名称',
      prop: "sellerCustName"
    },{
      label: '业务类型',
      prop: "factoringType",
      type: "select",
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
      props: {
        label: "dictValue",
        value: "dictKey"
      },      
      search: true,
      hide: true
    },
    // {
    //   label: '保理商',
    //   prop: "factoringEntity",
    //   type: "select",
    //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=rzzl_accounting_entity',
    //   props: {
    //     label: "dictValue",
    //     value: "dictKey"
    //   },      
    //   search: true,
    //   hide: true
    // },
    {
      label: '业务经理',
      prop: 'managerUserName',
      click: () => {
        selectPersonClick();
      }
    },{
      label: '所属部门',
      prop: 'managerDeptName',
      click: () => {
        selectDeptClick();
      }
    },{
      label: '立项状态',
      prop: "auditStatus",
      type: "select",
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_build_state',
      props: {
        label: "dictValue",
        value: "dictKey"
      },      
      search: true,
      hide: true
    },
    // {
    //   label: '审核状态',
    //   prop: "auditStatus",
    //   type: "select",
    //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
    //   props: {
    //     label: "dictValue",
    //     value: "dictKey",
    //   },
    //   formatter: (row, value, label, column) => {
    //     return label ? label : "未提交";
    //   },
    //   dataType: "string",      
    //   search: true,
    //   hide: true
    // }
    ]
  }
}

export function factoringAddFormConfig(selectPersonClick) {
  return {
    labelWidth: 140,
    emptyBtn: false,
    submitBtn: false,
    column: [{
      label: "项目名称",
      prop: "name",
      formslot: true,
      disabled: false,
      placeholder: "等待生成项目名称",
    },{
      label: "保理类型",
      prop: "projectType",
      type: "select",
      disabled: false,
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      rules: [{
        required: true,
        message: "请选择保理类型",
        trigger: "change"
      }]      
    },{
      // 选择类型
      label: "卖方(债权人)",
      prop: "sellerCustId",
      disabled: false,
      dicUrl: '/api/blade-/zd/custom/dict',
      dicMethod:'post',
      dicQuery:{
        custType: 2
      },
      formslot: true,
      rules: [{
        required: true,
        message: "请选择卖方",
        trigger: "change"
      }]
    },{
      label: "买方(债务人)",
      prop: 'buyerCustName',
      disabled: false,
      rules: [{
        required: true,
        message: "请选择买方",
        trigger: "change"
      }]
    },
    // {
    //   label: '项目编号',
    //   prop: 'number',
    //   disabled: true
    // },{
    //   label: '业务主办',
    //   prop: 'managerUserName',
    //   alwaysDisabled: true,
    //   disabled: true
    // },{
    //   label: '业务协办',
    //   prop: 'assistUserName',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   click: () => {
    //     selectPersonClick();
    //   }        
    // },
    {
      label: "项目来源",
      prop: "projectComeFrom",
      type: "select",
      disabled: false,
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_source',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      rules: [{
        required: true,
        message: "请选择项目来源",
        trigger: "change"
      }]      
    },{
      label: '担保方式', 
      prop: 'guaranteeMethod',
      disabled: false,
      // type: "select",
      // dicUrl: '/api/blade-system/dict-biz/dictionary?code=factoring_guarantee_method',
      // props: {
      //   label: "dictValue",
      //   value: "dictKey"
      // },
      rules: [{
        required: true,
        message: "请输入担保方式",
        trigger: "blur" 
      }]
    },
    // {
    //   label: "所属行业",
    //   prop: "industry",
    //   disabled: true,
    //   alwaysDisabled: true,
    //   width: "120"
    // },{
    //   label: "保理额度",
    //   prop: 'factoringCredit',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   append: '元',
    // },{
    //   label: "报价方案",
    //   prop: "quotaPlan",
    //   formslot: true,
    // },{
    //   label: "保理融资期限",
    //   prop: 'financingMaturity',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   append: '月',
    // },{
    //   label: "宽限期",
    //   prop: 'gracePeriod',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   append: '天',
    // },{
    //   label: "宽限期费率",
    //   append: '%',
    //   prop: 'graceRate',
    //   disabled: true,
    //   alwaysDisabled: true,
    // },{
    //   label: "手续费",
    //   prop: 'poundage',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   append: '元',
    // },{
    //   label: "手续费收取方式",
    //   prop: 'poundageChargeType',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   type: "select",
    //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=outlay_way',
    //   props: {
    //     label: "dictValue",
    //     value: "dictKey"
    //   },
    // },{
    //   label: "保证金",
    //   append: '元',
    //   prop: 'cashDeposit',
    //   disabled: true,
    //   alwaysDisabled: true,
    // },{
    //   label: "保证金收取方式",
    //   prop: 'cashDepositChargeType',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   type: "select",
    //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=outlay_way',
    //   props: {
    //     label: "dictValue",
    //     value: "dictKey"
    //   },
    // },{
    //   label: "保证金归还方式",
    //   prop: 'cashDepositReturnType',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   type: "select",
    //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=expiration_treatment',
    //   props: {
    //     label: "dictValue",
    //     value: "dictKey"
    //   },
    // },{
    //   label: '逾期使用费率',
    //   prop: "overdueUsageRate",
    //   disabled: true,
    //   alwaysDisabled: true,
    //   append: '%',
    // },{
    //   label: "保理首付款",
    //   prop: 'downParmentStr',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   append: '元',
    // },{
    //   label: "保理首付款使用费率",
    //   prop: 'downParmentUsageRate',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   labelWidth: 160,
    //   append: '%',
    // },{
    //   label: "内部收益率",
    //   prop: 'xirrStr',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   append: '%',
    // },
    {
      label: '还款方式',
      prop: 'repaymentType',
      type: 'select',
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=repayment_frequency',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      dataType:'string',
      value:'1',
      disabled: true,
      rules: [{
        required: true,
        message: "请选择还款方式",
        trigger: "blur" 
      }]
    },
    {
      label: '是否为保理池项目',
      prop: 'isBlPool',
      type: 'select',
      dicData: [
        {
         label:'是',
         value:1
        },
        {
          label:'否',
          value:0
         }
      ],
      disabled: false,
    },

    {
      label: "报价方案",
      prop: "quotaPlan",
      formslot: true,
      span: 24,
      rules: [{
        required: true,
        message: "请选择报价方案",
        trigger: "blur" 
      }]      
    },
    {
      label: '特别操作说明',
      type: 'textarea',
      disabled: false,
      prop: 'remarks',
      span: 24
    }]
  }
}

export function extraForm() {
  return [
    {
      label: '项目编号',
      prop: 'number',
      span: '12'
    },{
      label: '所属部门',
      prop: "managerDeptName",
      span: '12'
    },{
      label: '业务主办',
      prop: "managerUserName",
      span: '12'
    },{
      label: '业务协办',
      prop: "assistUserName",
      span: '12'
    },{
      label: '融资额度',
      prop: "factoringCreditStr",
      span: '12',
      unit: '元'
    },{
      label: '保理融资期限',
      prop: "financingMaturity",
      span: '12',
      unit: '天'
    },{
      label: '保理转让款使用费率',
      prop: "annualInterestRateStr",
      unit: '%',
      span: '12'
    },{
      label: '内部收益率',
      prop: "xirrStr",
      unit: '%',
      span: '12'
    },{
      label: '逾期使用费率',
      prop: "overdueInterestRateStr",
      unit: '%',
      span: '12'
    },{
      label: '手续费',
      prop: "poundageStr",
      unit: '元',
      span: '12'
    },{
      label: '手续费收取方式',
      prop: "poundageChargeTypeStr",
      span: '12'
    },{
      label: '保证金',
      prop: "cashDepositStr",
      span: '12',
      unit: '元'
    },{
      label: '保证金收取方式',
      prop: "cashDepositChargeTypeStr",
      span: '12'
    },{
      label: '保证金归还方式',
      prop: "cashDepositReturnTypeStr",
      span: '12'
    },{
      label: '宽限期',
      prop: "gracePeriod",
      span: '12',
    },{
      label: '宽限期费率',
      prop: "graceRateStr",
      span: '12',
    }
  ]
}

export function buildProjectConfig() {
  return [
    {
      label: '融资额度(元)',
      prop: 'factoringCredit',
    },
    {
      label: '敞口金额',
      prop: 'finStandard',
    },
    {
      label: '租赁物风险敞口比率',
      prop: 'riskExposure',
    },
    {
      label: '租金计算方式',
      prop: 'calculateRentMethod',
    },
    {
      label: '租金还款频次',
      prop: 'repaymentFrequency',
    },
    {
      label: '还款期限',
      prop: 'leaseTerm'
    },
    {
      label: '手续费'
    },
    {
      label: '手续费扣款方式'
    },
    {
      label: '内部收益率'
    },
    {
      label: '保证金'
    },
    {
      label: '保证金扣款方式'
    },
    {
      label: '保证金退还方式'
    },
    {
      label: '利率模式'
    },
    {
      label: '浮动方式'
    },
    {
      label: '名义货价'
    },
    {
      label: '担保方式'
    },
    {
      label: '担保方式说明',
      placeholder: '请输入担保方式',
      prop: 'introGuaranteeMethodExplain',
      type: 'input',
      span: '24'
    },
    {
      label: '租赁标的物',
      placeholder: '请输入租赁标的物',
      prop: 'introLeaseSubjectMatter',
      type: 'input',
      span: '24'
    },
    {
      label: '资金用途',
      placeholder: '请输入资金用途',
      prop: 'introFundsUse',
      type: 'input',
      span: '24'      
    },
    {
      label: '项目在建情况',
      placeholder: '请输入项目在建情况',
      prop: "introProjectState",
      type: 'input',
      span: '24'
    },
    {
      label: '特别操作说明',
      placeholder: '请输入特别操作说明',
      prop: 'introSpecialOperation',
      type: 'input',
      span: '24'
    },
    {
      label: '备注',
      placeholder: '请输入备注',
      prop: ' introRemark',
      type: 'textarea',
      span: '24'
    }
  ]
}

export function customerConfig() {
  return [
    {
      label: '客户名称',
      prop: 'custName',
      span: '12'
    },
    {
      label: '客户类别',
      prop: 'custCategoryStr',
      span: '12',
      // formatter: (label, value) => {
      //   let returnData = value == 1?'个人客户':value == 2?'机构客户':'无'
      //   return returnData
      // }
    },
    {
      label: '客户来源',
      prop: 'custSourceStr',
      span: '12'
    },
    {
      label: '客户性质',
      prop: 'custAttributeStr',
      span: '12'
    },
    {
      label: '所属行业',
      prop: 'industryStr',
      span: '12'
    },
    {
      label: '企业类型',
      prop: 'enterpriseTypeStr',
      span: '12'
    },
    {
      label: '企业规模',
      prop: 'enterpriseScaleStr',
      span: '12'
    },
    {
      label: '统一社会信用代码',
      prop: 'unifiedSocialCreditCode',
      span: '12'
    },
    {
      label: '注册资本(万元)',
      prop: 'registeredCapital',
      span: '12'
    },
    {
      label: '成立时间',
      prop: 'fundingTime',
      span: '12'
    },
    {
      label: '联系电话',
      prop: 'contactNumber',
      span: '12'
    },
    {
      label: '注册地址',
      prop: 'registeredAddress',
      span: '12'
    },
    {
      label: '办公地址',
      prop: 'officeAddress',
      span: '12'
    },
    {
      label: '企业概况',
      prop: 'custCompanyState',
      disabled: false,
      placeholder: '请输入企业概况',
      type: 'textarea',
      span: '24'
    },
    {
      label: '主要产品及销售状况',
      prop: 'custProductSalesState',
      disabled: false,
      placeholder: '请输入主要产品及销售状况',
      type: 'textarea',
      span: '24'
    },
    {
      label: '资产负债情况',
      prop: 'custPropertyState',
      disabled: false,
      placeholder: '请输入资产负债情况',
      type: 'textarea',
      span: '24'
    },
    {
      label: '其他',
      prop: 'custOther',
      disabled: false,
      placeholder: '请输入',
      type: 'textarea',
      span: '24'
    },            
  ]
}